var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFvPear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F6FAE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_36344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4737 3.98431C14.8063 4.51479 14.1646 5.30196 13.6398 6.46274C11.5407 11.0973 13.7482 11.3569 8.98244 17.9651C4.21666 24.5733 4.04839 40.1312 20.1881 40C36.3279 39.8916 35.6691 24.3137 30.7578 17.7768C25.8466 11.2399 28.0484 10.9462 25.8466 6.34581C24.5176 3.57077 22.5582 2.96898 21.212 2.92905C21.212 2.92905 19.0616 -1.48592 15.6077 0.527629C13.2463 1.90232 15.4737 3.98717 15.4737 3.98717V3.98431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0025 6.55687C20.0025 6.55687 20.359 2.63245 17.9491 1.82532C15.5391 1.01819 16.697 2.52407 16.697 2.52407C16.697 2.52407 18.9787 2.06489 19.4835 6.69662C19.6061 7.80892 19.9997 6.67951 19.9997 6.67951",
    fill: "#544223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2982 18.795C15.0772 13.3647 13.3289 13.1508 14.9973 9.34333C16.6658 5.53584 19.803 6.5911 19.803 6.5911C19.803 6.5911 22.9232 5.45883 24.6601 9.2321C26.3969 13.0082 24.6543 13.2506 28.5331 18.6125C32.4119 23.9743 32.9139 36.7629 20.1424 36.8713C7.37092 36.9997 7.51923 24.2253 11.301 18.795H11.2982Z",
    fill: "#CEED5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9277 33.3169C25.9277 33.3169 25.8198 33.3501 25.6975 33.4257C25.5716 33.4982 25.4313 33.616 25.3126 33.7429C25.1867 33.8607 25.0824 33.9936 25.0177 34.1084C24.9529 34.2202 24.9277 34.3169 24.9277 34.3169C24.9277 34.3169 25.0356 34.2927 25.1687 34.2263C25.3018 34.1598 25.4601 34.051 25.5968 33.9272C25.7155 33.7973 25.809 33.6522 25.863 33.5314C25.9169 33.4136 25.9277 33.3169 25.9277 33.3169Z",
    fill: "#9DC639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9277 33.3169C24.9277 33.3169 24.8402 33.3509 24.7341 33.4325C24.6811 33.4734 24.6227 33.5278 24.5617 33.5754C24.5007 33.6264 24.4423 33.6876 24.384 33.7489C24.3256 33.8101 24.262 33.8679 24.2116 33.9325C24.1585 34.0006 24.1081 34.0584 24.0657 34.1094C23.9808 34.2149 23.9277 34.3169 23.9277 34.3169C23.9277 34.3169 24.0153 34.3169 24.1399 34.2795C24.2699 34.2489 24.4105 34.1366 24.5484 34.0142C24.6094 33.9393 24.6731 33.8679 24.7235 33.7897C24.7792 33.7149 24.8137 33.6366 24.8429 33.5686C24.9039 33.4291 24.9277 33.3169 24.9277 33.3169Z",
    fill: "#9DC639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.761 21.3242C24.2072 21.2551 24.7041 21.6901 24.8638 22.0662C25.0844 22.5806 24.6991 23.1128 24.2402 23.274C23.8193 23.4224 23.1703 23.1716 22.9954 22.7392C22.7672 22.1686 23.1399 21.4189 23.7585 21.3242H23.761Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4616 16.3224C23.8027 16.2973 24.1158 16.3571 24.461 16.5228C24.8944 16.7329 25.075 17.0432 24.7901 17.3169C24.3887 16.9314 23.8348 16.5479 22.9277 16.4187C23.1164 16.3667 23.293 16.3339 23.4616 16.3224Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5213 16.2784C16.0617 15.9804 15.1491 16.2579 15.2147 17.1678C15.6958 16.9105 16.2761 16.5824 16.8834 16.529L16.5219 16.2758L16.5213 16.2784Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2051 25.32C20.8563 25.2795 21.6022 25.6347 21.8346 26.289C22.0516 26.8965 21.8865 27.6505 21.3699 28.0493C20.8869 28.4201 20.1623 28.3765 19.6457 28.0961C19.0068 27.7502 18.7897 26.9246 19.0129 26.236C19.2085 25.6347 19.6885 25.3543 20.2051 25.3231V25.32Z",
    fill: "#7F1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.761 21.3242C17.2072 21.2551 17.7041 21.6901 17.8638 22.0662C18.0844 22.5806 17.6991 23.1128 17.2402 23.274C16.8193 23.4224 16.1703 23.1716 15.9954 22.7392C15.7672 22.1686 16.1399 21.4189 16.7585 21.3242H16.761Z",
    fill: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_36344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6592,
    height: 40,
    fill: "white",
    transform: "translate(6.16992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvPear);
export default __webpack_public_path__ + "static/media/fv-Pear.496cf04403fd294ee9b38f54ddddb62c.svg";
export { ForwardRef as ReactComponent };